import Header from "../../component/layout/header";
import { Outlet } from "react-router";

import PageLayout from "../../component/layout/page-layout/layout";
import useNav from "../../script/tabingNavArray";

const OrganizationLayout = () => {
  const navList = useNav();
  let { topHeaderNav, organizationBottomNav } = navList;
  return (
    // <div className="webBody">
    //   <Header  bottomTabs={organizationBottomNav} topTabs={topHeaderNav}/>
    //   <Outlet />
    // </div>
    <PageLayout top={topHeaderNav} bottom={organizationBottomNav} />
  );
};

export default OrganizationLayout;
